export default {
  Team: {
    TITLE: 'Team',
    INVITE: 'Invite a Teammate',
    MEMBERS: 'Members',
    PENDING: 'Pending',
    Table: {
      NAME: 'Name',
      EMAIL: 'Email',
      PERMISSIONS: 'Permissions',
      STATUS: 'Status',
      COMPLETE: 'Complete',
      WAITING: 'Invited',
      Permission: {
        owner: 'Owner',
        readwrite: 'User',
        read: 'Read only',
      },
    },
    Invite: {
      TITLE: 'Invite a Teammate',
      DESCRIPTION:
        'Use their Xero login email to invite them to collaborate with you on Mayday',
      INVITE: 'Send Invite',
      RESEND: 'Resend Invite',
      FORM_ERROR: 'There was an error. Please check the form and try again.',
      ADD_ANOTHER: '+ Invite another user',
      RESEND_BODY:
        'Resend invite email to {{email}} to invite them to collaborate with you on Mayday?',
    },
    Remove: {
      TITLE: 'Remove User',
      DESCRIPTION:
        'Are you sure you would like to remove {{user}} from your group?',
      REMOVE: 'Remove',
    },
    // read and readwrite placeholders for when we want to allow this level of user access management
    read: {
      TITLE: 'Change access to read only for {{name}}',
      DESCRIPTION:
        'Changing {{user}} access to read-only will mean they cannot make any changes to your group.',
      CONFIRM: 'Change {{forename}} to read-only',
    },
    readwrite: {
      TITLE: 'Change access to read and write access for {{name}}',
      DESCRIPTION: 'Changing {{user}} access to read and write access...',
      CONFIRM: 'Change {{forename}} to read-only',
    },
    owner: {
      TITLE: 'Reassign ownership to {{name}}',
      DESCRIPTION:
        'Making {{user}} the owner will give them full team management permissions and remove your own. It will not affect billing - if you wish to update your billing details, visit the "Billing" page.',
      CONFIRM: 'Make {{forename}} the owner',
    },
    Access: {
      DELEGATE_MESSAGE:
        "This user is the group's billing manager. Contact support if you wish to remove this user",
      REMOVE_USER: 'Remove user from group',
    },
  },
};
